import isEmpty from "lodash/isEmpty";
import { TemplateKey } from "PFApp/constants/templates";

import { useTemplate } from "./use_template";

export const useHasSubtemplates = (templateKey?: TemplateKey) => {
  const template = useTemplate(templateKey);

  return !!template?.schema?.subtemplates && !isEmpty(template.schema.subtemplates);
};
